import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const QuestionInfoIcon = memo(({ className, fontSize = 120 }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="122"
    height="122"
    viewBox="0 0 122 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fontSize, fill: 'none' }}
  >
    <g clipPath="url(#clip0_9255_70974)">
      <path
        d="M47.9736 86.7057C69.6413 86.7057 87.208 69.1391 87.208 47.4713C87.208 25.8035 69.6413 8.23688 47.9736 8.23688C26.3058 8.23688 8.73914 25.8035 8.73914 47.4713C8.73914 69.1391 26.3058 86.7057 47.9736 86.7057Z"
        fill="#F0CBA7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.79163 44.7643C3.79163 22.4088 21.9158 4.28459 44.2713 4.28459C66.6268 4.28459 84.751 22.4088 84.751 44.7643C84.751 67.1198 66.6268 85.244 44.2713 85.244C21.9158 85.244 3.79163 67.1198 3.79163 44.7643ZM44.2713 6.77514C23.2913 6.77514 6.28217 23.7843 6.28217 44.7643C6.28217 65.7443 23.2913 82.7534 44.2713 82.7534C65.2514 82.7534 82.2605 65.7443 82.2605 44.7643C82.2605 23.7843 65.2514 6.77514 44.2713 6.77514Z"
        fill="#EA7200"
      />
      <path
        d="M45.7369 67.0651V38.6276"
        stroke="#226937"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.737 31.0443C47.8311 31.0443 49.5286 29.3467 49.5286 27.2526C49.5286 25.1585 47.8311 23.4609 45.737 23.4609C43.6429 23.4609 41.9453 25.1585 41.9453 27.2526C41.9453 29.3467 43.6429 31.0443 45.737 31.0443Z"
        fill="#226937"
      />
    </g>
    <path
      d="M85.4461 103.08L71.091 87.7858C69.759 86.3668 69.611 84.1069 70.8443 82.5827C72.1762 80.9535 74.5441 80.9009 75.9253 82.4251L85.1008 92.2006C83.6702 90.6764 83.7196 88.2063 85.2488 86.7872C86.63 85.4733 88.8006 85.631 90.1325 87.05L92.7964 89.8881C91.3658 88.3639 91.4151 85.8938 92.9443 84.4748C94.3256 83.1609 96.4961 83.3185 97.8281 84.7376L100.245 87.3128C98.8147 85.7887 98.864 83.3185 100.393 81.8995C101.775 80.5856 103.945 80.7433 105.277 82.1623L120.224 98.0869C121.359 99.2957 122 100.872 122 102.554C122 102.554 122 102.554 122 102.607C122 106.443 120.619 110.07 118.054 112.75L113.318 117.795C110.802 120.476 107.349 122 103.748 122H75.432C74.6427 122 73.9521 121.317 73.9521 120.476C73.9028 118.479 75.284 116.797 77.1586 116.482L92.2044 113.959C92.8457 113.854 93.3883 113.276 93.487 112.592C93.5363 112.067 93.339 111.594 93.043 111.226L85.9888 103.71L84.5582 102.186L74.8401 91.8327"
      fill="#F0CBA7"
    />
    <path
      d="M82.4461 101.08L68.091 85.7858C66.759 84.3668 66.611 82.1069 67.8443 80.5827C69.1762 78.9535 71.5441 78.9009 72.9253 80.4251L82.1008 90.2006C80.6702 88.6764 80.7195 86.2063 82.2488 84.7872C83.63 83.4733 85.8006 83.631 87.1325 85.05L89.7964 87.8881C88.3658 86.3639 88.4151 83.8938 89.9443 82.4748C91.3256 81.1609 93.4961 81.3185 94.8281 82.7376L97.2453 85.3128C95.8147 83.7887 95.864 81.3185 97.3933 79.8995C98.7745 78.5856 100.945 78.7433 102.277 80.1623L117.224 96.0869C118.359 97.2957 119 98.8724 119 100.554C119 100.554 119 100.554 119 100.607C119 104.443 117.619 108.07 115.054 110.75L110.318 115.795C107.802 118.476 104.349 120 100.748 120H72.432C71.6427 120 70.9521 119.317 70.9521 118.476C70.9028 116.479 72.284 114.797 74.1586 114.482L89.2044 111.959C89.8457 111.854 90.3883 111.276 90.487 110.592C90.5363 110.067 90.339 109.594 90.043 109.226L82.9888 101.71L81.5582 100.186L71.8401 89.8327"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_9255_70974">
        <rect width="91" height="91" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
));
